(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[422],{

/***/ 15236:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[business]/access/[category]/[article]",
      function () {
        return __webpack_require__(95619);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ NotificationAutoPadding; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);

const NotificationAutoPadding = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            paddingTop: "var(--noti-height"
        }
    });
};


/***/ }),

/***/ 95619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75102);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57656);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42132);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75407);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62991);
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21776);
/* harmony import */ var _components_back_to_latest_article_back_to_latest_article__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44490);
/* harmony import */ var _components_business_article_bio_block_business_article_bio_block__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26094);
/* harmony import */ var _components_business_article_categories_block_business_article_categories_block__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43770);
/* harmony import */ var _components_business_article_contributor_block_business_article_contributor_block__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99948);
/* harmony import */ var _components_business_article_single_hero_business_article_single_hero__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72379);
/* harmony import */ var _components_business_share_icons_business_share_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78916);
/* harmony import */ var _components_layouts_default_layout__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87369);
/* harmony import */ var _components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22135);
/* harmony import */ var _components_newsletter_signup_section_newsletter_signup_section__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37048);
/* harmony import */ var _components_notification_auto_padding_notification_auto_padding__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29132);
/* harmony import */ var _components_related_articles_related_articles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(13510);
/* harmony import */ var _helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(31198);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(77868);




















(0,_builder__WEBPACK_IMPORTED_MODULE_6__/* .registerComponents */ .QR)();
var __N_SSG = true;
function Page(ctx) {
    var ref, ref1;
    const { article , relatedArticles  } = ctx;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_19__/* .useLocale */ .bU)();
    const [stateArticle, setStateArticle] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(article);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        let cancelled = false;
        if ((_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isPreviewing */ .Ib.isPreviewing || _builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isEditing */ .Ib.isEditing) && router.query["builder.overrides.article"]) {
            (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_18__/* .getArticleFromID */ .NE)(router.query["builder.overrides.article"]).then((articleFromBuilder)=>{
                if (articleFromBuilder && !cancelled) {
                    const mappedArticle = (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_18__/* .mapBuilderObjectToArticle */ .Jq)(articleFromBuilder);
                    setStateArticle(mappedArticle);
                }
            });
        } else {
            if (article) {
                setStateArticle(article);
            }
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        stateArticle,
        router.query
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>setStateArticle(article), [
        article
    ]);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            children: "Loading..."
        });
    }
    const isLive = !_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isEditing */ .Ib.isEditing && !_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isPreviewing */ .Ib.isPreviewing;
    if (!stateArticle && isLive) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "robots",
                            content: "noindex"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "title"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: 404
                })
            ]
        });
    }
    if (!stateArticle) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            children: "Loading..."
        });
    }
    const leadCategory = (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_18__/* .mapBuilderObjectToCategory */ .yP)(article === null || article === void 0 ? void 0 : article.categories[0]);
    const relatedArticlesData = {
        title: leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.name,
        description: leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.description,
        viewAllSeriesText: "View All Articles",
        viewAllSeriesUrl: (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_19__/* .localifyLink */ .Bj)("/".concat(locale).concat(leadCategory.categoryUrl), locale),
        articles: relatedArticles
    };
    var ref2, ref3, ref4;
    const breadcrumbItems = [
        {
            link: "/business/access",
            name: "Access"
        },
        {
            link: (ref2 = leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.categoryUrl) !== null && ref2 !== void 0 ? ref2 : "",
            name: (ref3 = leadCategory === null || leadCategory === void 0 ? void 0 : leadCategory.name) !== null && ref3 !== void 0 ? ref3 : ""
        },
        {
            link: "",
            name: (ref4 = article === null || article === void 0 ? void 0 : article.title) !== null && ref4 !== void 0 ? ref4 : ""
        }
    ];
    let targetUrl = "/".concat(locale).concat(article.articleUrl);
    if (true) {
        targetUrl = "".concat((window === null || window === void 0 ? void 0 : window.origin) || "", "/").concat(locale).concat(article.articleUrl);
    }
    var _seoTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                title: (_seoTitle = article.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : article.title,
                description: article.seoDescription,
                leadImage: article.leadImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_default_layout__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_notification_auto_padding_notification_auto_padding__WEBPACK_IMPORTED_MODULE_16__/* .NotificationAutoPadding */ .m, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_article_single_hero_business_article_single_hero__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        article: article,
                        breadcrumbs: breadcrumbItems
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .BuilderComponent */ .VD, {
                        model: "article",
                        content: stateArticle.builderModel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_article_categories_block_business_article_categories_block__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        categories: stateArticle.categories
                    }),
                    article.author && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_article_bio_block_business_article_bio_block__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        articleAuthor: stateArticle.author
                    }),
                    !!((ref = article.contributors) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_article_contributor_block_business_article_contributor_block__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        contributors: article.contributors,
                        hasAuthorBefore: !!((ref1 = article.author) === null || ref1 === void 0 ? void 0 : ref1.name)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_business_share_icons_business_share_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        shareUrl: targetUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_back_to_latest_article_back_to_latest_article__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        latestArticleUrl: (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_19__/* .localifyLink */ .Bj)("/".concat(locale, "/business/access"), locale)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_related_articles_related_articles__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        relatedArticles: relatedArticlesData
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_newsletter_signup_section_newsletter_signup_section__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [565,886,369,343,774,888,179], function() { return __webpack_exec__(15236); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);